import React, { DetailedHTMLProps, HTMLAttributes } from "react";

// assets
import styles from "@/assets/styles/layouts/single-page-layout.module.scss";


interface SinglePageLayoutInterface extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  className?: string;
}

function SinglePageLayout({ children, className = "", ...rest }: SinglePageLayoutInterface) {

  return (
    <section className={`locl-single-page-layout ${styles["locl-single-page-layout"]} ${className}`} { ...rest }>
      <div className={`locl-single-page-layout__content ${styles["locl-single-page-layout__content"]}`}>
        { children }
      </div>
    </section>
  );
}

export default SinglePageLayout;
